// Main Containers
import MainHome from '@/containers/main_home'

export const MainHomeRoute = {
  path: '/',
  name: 'Home',
  component: MainHome
}



// WEBPACK FOOTER //
// ./src/routers/main.js